import type { Job, Grower } from "../../../../../../models";
import { CREATE_NEW_GROWER } from "../../../../../../utilities/constants";
import { ColumnContext } from "../standard-column-types";
import { GrowerColumnViewModel } from "./Grower.column.types";

/**
 * Hook that provides the GrowerColumn ViewModel
 * @param context - The column context containing state and helpers
 * @returns ViewModel with all business logic functions
 */
export function useGrowerColumnViewModel(context: ColumnContext): GrowerColumnViewModel {
	/**
	 * Get all growers from context props
	 */
	function getAllGrowers(): Grower[] {
		return context.props.growers || [];
	}

	/**
	 * Get current selected grower for job
	 */
	function getSelectedGrower(job: Job): Grower | { id: string; name: string } | null {
		const growerId = job?.growerIds?.[0];
		if (!growerId) return null;

		if (growerId === CREATE_NEW_GROWER) {
			return job.importGrowerName ? { id: CREATE_NEW_GROWER, name: job.importGrowerName } : null;
		}

		const allGrowers = getAllGrowers();
		return allGrowers.find((g) => g.id === growerId) || null;
	}

	return {
		getAllGrowers,
		getSelectedGrower,
	};
}
